var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignLeft = function SvgIconAlignLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75a1 1 0 0 1 1 1v16.5a1 1 0 1 1-2 0V3.75a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 6c0-.966.784-1.75 1.75-1.75h8.25c.966 0 1.75.784 1.75 1.75v3.375a1.75 1.75 0 0 1-1.75 1.75H8.25a1.75 1.75 0 0 1-1.75-1.75zm2 .25v2.875h7.75V6.25zM8.25 12.875a1.75 1.75 0 0 0-1.75 1.75V18c0 .966.784 1.75 1.75 1.75h12A1.75 1.75 0 0 0 22 18v-3.375a1.75 1.75 0 0 0-1.75-1.75zm.25 4.875v-2.875H20v2.875z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlignLeft;